import { GetSellerPayLinkResponse } from '@iwoca/lapi-client/edge';
export const examplePayLinksResponse: GetSellerPayLinkResponse = {
  meta: {
    count: 1,
    total_pages: 1,
    totals_by_status: {
      APPROVED: 1,
      DECLINED: 1,
      NOT_SIGNED_UP: 1,
      PAID: 1,
      SIGNED_UP: 1,
      CANCELLED: 0,
      SCHEDULED_FOR_CAPTURE: 0,
    },
  },
  links: {
    first:
      'https://www.iwoca.co.uk/api/lending/edge/pay_link/?page=1&is_archived=false',
    last: 'https://www.iwoca.co.uk/api/lending/edge/pay_link/?page=1&is_archived=false',
    self: 'https://www.iwoca.co.uk/api/lending/edge/pay_link/?page=1&is_archived=false',
  },
  data: [
    {
      id: '1',
      reference: 'Example payment',
      amount: 999,
      created: '2022-11-19T12:00:00Z',
      buyer_name: 'Business name',
      seller_name: 'Your business name',
      funding_date: '2022-11-20T12:00:00Z',
      source: 'iwocaPay_ecommerce_api',
      order: {
        order_id: '1',
        status: 'COMPLETE',
      },
      status: 'PAID',
      product_duration: 'THREE_MONTHS',
      shopify_payment_id: '',
    },
    {
      id: '2',
      reference: 'Example payment',
      amount: 980,
      created: '2022-11-18T12:00:00Z',
      buyer_name: 'Business name',
      seller_name: 'Your business name',
      approval_date: '2022-11-18T12:00:00Z',
      source: 'iwocaPay_woocommerce_extension',
      // @ts-expect-error
      order: null,
      status: 'SIGNED_UP',
      // @ts-expect-error
      product_duration: null,
    },
    {
      id: '3',
      reference: 'Example payment',
      amount: 8000,
      created: '2022-11-18T12:00:00Z',
      funding_date: '2022-11-18T12:00:00Z',
      buyer_name: 'Business name',
      seller_name: 'Your business name',
      source: 'iwocaPay',
      // @ts-expect-error
      order: null,
      status: 'APPROVED',
      // @ts-expect-error
      product_duration: null,
    },
    {
      id: '4',
      reference: 'Example payment',
      amount: 3010,
      created: '2022-11-16T12:00:00Z',
      buyer_name: 'Business name',
      seller_name: 'Your business name',
      funding_date: '2022-11-17T12:00:00Z',
      source: 'Xero',
      // @ts-expect-error
      order: null,
      status: 'DECLINED',
      // @ts-expect-error
      product_duration: null,
    },
    {
      id: '5',
      reference: 'Example payment',
      amount: 300,
      created: '2022-11-10T12:00:00Z',
      buyer_name: 'Business name',
      seller_name: 'Your business name',
      source: 'iwocaPayMe',
      // @ts-expect-error
      order: null,
      status: 'NOT_SIGNED_UP',
      // @ts-expect-error
      product_duration: null,
    },
  ],
};
